module.exports = __webpack_public_path__ + "img/well_on.76d1e178.svg";